/**
 * Utility functions for formatting store names
 */

/**
 * Format store name for display
 * Converts database store names to clean display names
 * 
 * Examples:
 * - "store_perth" → "Perth"
 * - "store_singapore" → "Singapore"
 * - "Singapore store" → "Singapore"
 * - "Perth store" → "Perth"
 * 
 * @param {string} storeName - The raw store name from database
 * @returns {string} - Formatted store name for display
 */
export const formatStoreName = (storeName) => {
  if (!storeName) return '';
  
  // Remove "store_" prefix and "store" suffix
  let formatted = storeName
    .replace(/^store_/i, '')
    .replace(/\s*store$/i, '')
    .trim();
  
  // Capitalize first letter
  formatted = formatted.charAt(0).toUpperCase() + formatted.slice(1).toLowerCase();
  
  return formatted;
};

/**
 * Get store display name from store object or string
 * @param {Object|string} store - Store object with name/store_id or store name string
 * @returns {string} - Formatted store name
 */
export const getStoreDisplayName = (store) => {
  if (!store) return '';
  
  // If it's an object, try to get the name property
  if (typeof store === 'object') {
    return formatStoreName(store.name || store.store_id || '');
  }
  
  // If it's a string, format it directly
  return formatStoreName(store);
};
